export const PaymentProvider = {
    CHECKOUT_HF: 'CHECKOUT-HF',
    CARDSTREAM: 'CARDSTREAM'
};
